import MainText from '../MainText';
import SubText from '../SubText';
import SummaryItem from '../SummaryItem';

interface HotelInfoProps {
  name: string;
  address: string;
}

const HotelInfo = ({ name, address }: HotelInfoProps) => (
  <SummaryItem icon="place" label="Hotel">
    <MainText fontSize={['lg', 'lg']}>{name}</MainText>
    <SubText>{address}</SubText>
  </SummaryItem>
);

export default HotelInfo;
